import React from "react";
import withShipment from "../../../withShipment";
import {
    MANAGE_GAME, SAVE_GAME
} from "./constants";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TextField
} from "@material-ui/core";
import SearchableTable from "../../global/Search/SearchableTable";
import SaveIcon from "@material-ui/icons/Save";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import {editGame, listGame, loadStartedSession} from "../../../redux/actions/settings";
import {userInfoSelector} from "../../../redux/selectors/auth";
import {gameSelector, loadStartedSessionSelector} from "../../../redux/selectors/settings";
import ActiveSessionLockBanner from "../../global/ActiveSessionLockBanner";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import {clearStatus} from "../../../redux/actions/global";
import {Tooltip} from "@mui/material";

class ManageGame extends SearchableTable {
    constructor(props) {
        super(props);
        this.state = {
            games: this.props.games || [],
            feedbackBarOpen: false,
            feedbackStatus: '',
            feedbackMessage: '',
            showDeleteDialog: false,
            rowToDelete: null,
        }
    }

    componentDidMount() {
        this.props.listGame(this.props.userInfo.selectedLocationId)
        this.pushMenuItems();
        this.props.loadStartedSession({ locationId: this.props.userInfo.selectedLocationId, isAssignMachine: true })
    }

    isLocked = () => {
        const s = this.props.startedSession;
        return !!(s && s.sessionStarted);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.games !== this.props.games) {
            if (this.props.games && this.props.games.length > 0) {
                this.setState({ games: [...this.props.games] });
            }
        }
        if (prevState.games !== this.state.games) {
            this.pushMenuItems();
        }
    }

    pushMenuItems = () => {
        if (this.props.onMenuItemsChange) {
            this.props.onMenuItemsChange(this.getContextualMenuItems());
        }
    };



    getContextualMenuItems = () => [
        {
            title: SAVE_GAME,
            icon: <SaveIcon />,
            onClick: this.handleSave,
            disabled: this.isSaveDisabled(),
        }
    ];

  handleSave = () => {
    const games = this.state.games.map(m => (m.type || '').trim().toLowerCase());
    const hasDuplicates = new Set(games).size !== games.length;

    if (hasDuplicates) {
      this.openFeedbackBar('error', 'Duplicate type are not allowed.');
      return;
    }

    const callback = (severity, message) => {
      if (severity) {
        this.openFeedbackBar('error', message || 'Failed to save games')
      } else {
        this.openFeedbackBar('success', message || 'Saved')
      }
    };

    this.props.editGame(this.state.games,this.props.userInfo.selectedLocationId, callback);
  };

    isSaveDisabled = () => {
        return this.isLocked() || this.state.games.some(game => !game.type);
    };


    addGameRow = () => {
        this.setState(prevState => {
            const updatedGames = [...prevState.games, {
                type: "",

            }];
            return { games: updatedGames };
        });
    };
    removeGameRow = (index) => {
        this.setState(prevState => {
            const updatedGames = prevState.games.filter((_, curIndex) => curIndex !== index);
            return { games: updatedGames };
        });
    };

    handleGameChange = (e, index) => {
        const { name, value } = e.target;
        this.setState(prevState => {
            const updatedGames = [...prevState.games];
            updatedGames[index] = {
                ...updatedGames[index],
                [name]: value,
            };

            return { games: updatedGames };
        });
    };

    openFeedbackBar = (status,message) => {
        this.setState({feedbackStatus: status, feedbackMessage: message,feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage:''}, () => {
            this.props.clearStatus()
        })
    }

    render() {
        const { games  } = this.state;

        return (
          <React.Fragment>
            {!this.props.embedded && (
              <TopToolbar
                pageName={MANAGE_GAME}
                menuItems={this.getContextualMenuItems()}
              />
            )}

            <FeedbackBar
              open={this.state.feedbackBarOpen}
              handleClose={this.closeFeedbackBar}
              severity={this.state.feedbackStatus}
              message={this.state.feedbackMessage}
            />

            {this.isLocked() && (
              <ActiveSessionLockBanner sessionId={this.props.startedSession?.sessionId} />
            )}

            <Dialog
              open={this.state.showDeleteDialog}
              onClose={() => this.setState({ showDeleteDialog: false })}
            >
              <DialogTitle>{'Confirm Delete'}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete this game?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={() => this.setState({ showDeleteDialog: false })}
                  style={{
                    width: '100px',
                    marginRight: '16px',
                    marginBottom: '16px',
                  }}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  onClick={() => {
                    this.removeGameRow(this.state.rowToDelete);
                    this.setState({
                      showDeleteDialog: false,
                      rowToDelete: null,
                    });
                  }}
                  color="primary"
                  style={{
                    width: '100px',
                    marginRight: '16px',
                    marginBottom: '16px',
                  }}
                >
                  {' '}
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                marginTop: '16px',
              }}
            >
              <div className="transaction-form-section">
                {games.map((game, index) => (
                  <div
                    className="row-manage-card"
                    style={{ marginTop: '24px', marginBottom: '24px' }}
                  >
                    <div
                      style={{
                        width: '2.5%',
                        display: 'flex',
                        marginRight: '50px',
                        marginLeft: '50px',
                      }}
                    >
                      <IconButton
                        onClick={() =>
                          this.setState({
                            showDeleteDialog: true,
                            rowToDelete: index,
                          })
                        }
                      >
                        <RemoveCircleIcon fontSize="medium" color="error" />
                      </IconButton>
                    </div>

                    <TextField
                      variant="outlined"
                      name="type"
                      label="Type"
                      InputLabelProps={{ shrink: true }}
                      value={game.type || ''}
                      onChange={(e) =>
                        this.handleGameChange(
                          {
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          },
                          index
                        )
                      }
                      required
                      error={
                        !game.type ||
                        games.some((m, i) => m.type === game.type && i !== index)
                      }
                      helperText={
                        !game.type
                          ? ''
                          : games.some((m, i) => m.type === game.type && i !== index)
                            ? 'Duplicate type'
                            : ''
                      }
                    />

                  </div>
                ))}
                <div style={{ marginTop: '30px', marginLeft: '24px' }}>
                    <Tooltip title={'Add game'}>
                          <IconButton onClick={this.addGameRow}>
                            <AddCircleIcon fontSize="medium" color="secondary" />
                          </IconButton>
                    </Tooltip>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    userInfo: userInfoSelector(state),
    games: gameSelector(state),
    startedSession: loadStartedSessionSelector(state),
})

const actionCreators = {
    listGame,
    clearStatus,
    editGame,
    loadStartedSession,
}
export default withShipment({
    mapStateToProps,
    actionCreators
}, ManageGame);